import { Alert, Spin } from 'antd'
import type { JSX } from 'react'
import styled from 'styled-components'

import { SettingsPage } from '../Settings'

import { LinkBrand } from './LinkBrand'
import { LinkCampaign } from './LinkCampaign'
import { RegistrationData } from './RegistrationData'
import { useCommunityTCRRegistrationQuery } from './useCommunityTCRRegistrationQuery'

import { CAPABILITIES } from 'constants/capabilities'
import { useHasCapability } from 'hooks/useCapabilities'

const StyledSpinContainer = styled.div`
  width: 100%;
  text-align: center;
  padding: 100px;
`

type TCRProps = {
  client: {
    id: string
  }
}

export function TCR({ client }: TCRProps): JSX.Element {
  const canWrite = useHasCapability(CAPABILITIES.ADMIN.TCR_REGISTRATION.WRITE)
  const disabledTooltip = 'You do not have the capability to manage TCR registration'
  const { data, isLoading, isError } = useCommunityTCRRegistrationQuery(client.id)

  if (isLoading) {
    return (
      <StyledSpinContainer>
        <Spin size="large" />
      </StyledSpinContainer>
    )
  }

  return (
    <SettingsPage description="Brand and campaign registration with The Campaign Registry." title="TCR">
      {isError && <Alert message="Could not load TCR registration data. Please try again." showIcon type="error" />}
      <RegistrationData
        canWrite={canWrite}
        clientId={client.id}
        disabledTooltip={disabledTooltip}
        registration={data?.data}
      />
      <LinkBrand brand={data?.data?.brand} canWrite={canWrite} clientId={client.id} disabledTooltip={disabledTooltip} />
      <LinkCampaign
        campaign={data?.data?.campaign}
        canWrite={canWrite}
        clientId={client.id}
        disabledTooltip={disabledTooltip}
      />
    </SettingsPage>
  )
}
